import HeaderLinks from './HeaderLinks';

export default HeaderLinks;